module.exports = __webpack_public_path__ + "img/weapon8.png";